<template>
  <div class="home">
    <RestaurantModest />
    <Kennismaking />
    <WaaromModest />
  </div>
</template>

<script>
// @ is an alias to /src
import RestaurantModest from "@/components/RestaurantModest.vue";
import Kennismaking from "@/components/Kennismaking.vue";
import WaaromModest from "@/components/WaaromModest.vue";

export default {
  name: "Home",
  components: {
    Kennismaking,
    RestaurantModest,
    WaaromModest
  }
};
</script>
